if (!customElements.get('featured-jewelry-carousel')) {
  customElements.define('featured-jewelry-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.la-hero__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('.la-hero__controls').hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-slide')) this.show(Number(button.dataset.slide));
        if (button.dataset.action === 'prev') this.show(this.index - 1);
        if (button.dataset.action === 'next') this.show(this.index + 1);
        if (button.dataset.action === 'pause') {
          this.paused = !this.paused;
          button.setAttribute('aria-pressed', String(this.paused));
          button.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
          this.schedule();
        }
      }, { signal });
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', () => {
        queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
      }, { signal });
      this.addEventListener('touchstart', (event) => {
        this.touch = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
      }, { passive: true, signal });
      this.addEventListener('touchend', (event) => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch[0];
        const dy = event.changedTouches[0].clientY - this.touch[1];
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
        this.touch = null;
      }, { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.show(index); }
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      this.show(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, current) => {
        const active = current === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active) slide.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      });
      this.dots.forEach((dot, current) => {
        if (current === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const running = this.dataset.autoplay === 'true' && !this.paused && !this.hovered && !this.focused && this.visible && !document.hidden && !this.motion.matches;
      this.querySelector('.la-hero__slides').setAttribute('aria-live', running ? 'off' : 'polite');
      if (running) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.speed) * 1000);
    }
  });
}
